// Address validation for Helium Customer Fields
console.log('🔍 ZIP Validation script loaded');

document.addEventListener('DOMContentLoaded', function() {
  console.log('🔍 DOM ready, initializing validation');
  initializeHeliumValidation();
});

function initializeHeliumValidation() {
  console.log('🔍 Starting form detection...');
  
  // Wait for Helium form to render
  const observer = new MutationObserver(function(mutations) {
    console.log('🔍 Mutation observed, checking for forms...');
    const form = document.querySelector(
      '.helium-customer-fields-form, ' +
      'form[action*="customer_fields"], ' +
      '#create_customer, ' +
      '.customer-fields-form, ' +
      'form[data-cf-form]'
    );
    
    if (form) {
      console.log('🔍 Form found via observer:', form);
      observer.disconnect();
      attachZipValidation(form);
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Also try immediate attachment and with CF ready callback
  setTimeout(() => {
    console.log('🔍 Timeout check for forms...');
    const form = document.querySelector('form[data-cf-form], .helium-customer-fields-form, form[action*="customer_fields"]');
    if (form) {
      console.log('🔍 Form found via timeout:', form);
      observer.disconnect();
      attachZipValidation(form);
    } else {
      console.log('🔍 No form found in timeout check');
    }
  }, 1000);

  // Use Customer Fields ready callback if available
  if (window.CF && window.CF.ready) {
    console.log('🔍 Using CF ready callback');
    window.CF.ready(function() {
      console.log('🔍 CF ready callback triggered');
      const form = document.querySelector('form[data-cf-form]');
      if (form) {
        console.log('🔍 Form found via CF ready:', form);
        attachZipValidation(form);
      }
    });
  } else {
    console.log('🔍 CF not available yet');
  }
}

function attachZipValidation(form) {
  console.log('🔍 Customer Fields form found, attaching validation to:', form);
  
  // Debug: Log all form inputs to see what we're working with
  const allInputs = form.querySelectorAll('input, select');
  console.log('🔍 All form inputs:', allInputs);
  allInputs.forEach((input, index) => {
    console.log(`🔍 Input ${index}:`, {
      name: input.name,
      id: input.id,
      type: input.type,
      placeholder: input.placeholder,
      autocomplete: input.autocomplete,
      'data-cf-column-key': input.getAttribute('data-cf-column-key')
    });
  });
  
  // Find fields - Customer Fields uses specific naming patterns
  const zipField = form.querySelector(
    'input[name="default_address.zip"], ' +
    'input[name*="zip"], ' +
    'input[name*="postal"], ' +
    'input[data-cf-column-key*="zip"], ' +
    'input[autocomplete="postal-code"], ' +
    'input[placeholder*="ZIP"], ' +
    'input[placeholder*="zip"], ' +
    'input[placeholder*="Postal"]'
  );
  
  const stateField = form.querySelector(
    'select[name="default_address.province"], ' +
    'select[name*="state"], ' +
    'select[name*="province"], ' +
    'input[name*="state"], ' +
    'select[data-cf-column-key*="state"], ' +
    'select[data-cf-column-key*="province"], ' +
    'select[autocomplete="address-level1"]'
  );
  
  console.log('🔍 ZIP field found:', zipField);
  console.log('🔍 State field found:', stateField);
  
  if (!zipField) {
    console.warn('🚨 ZIP field not found in Customer Fields form');
    return;
  }
  
  // Real-time validation on blur
  zipField.addEventListener('blur', function() {
    console.log('🔍 ZIP field blur event triggered');
    validateZipCode(this, stateField);
  });
  
  // Intercept form submission
  const originalSubmit = form.submit;
  form.submit = async function() {
    console.log('🔍 Form.submit() called programmatically');
    const isValid = await validateZipCode(zipField, stateField);
    if (isValid) {
      console.log('🔍 Validation passed, proceeding with original submit');
      originalSubmit.apply(this, arguments);
    } else {
      console.log('🚨 Validation failed, blocking programmatic submit');
    }
  };
  
  form.addEventListener('submit', async function(e) {
    console.log('🔍 Form submit event triggered');
    const isValid = await validateZipCode(zipField, stateField);
    if (!isValid) {
      console.log('🚨 Validation failed, preventing form submission');
      e.preventDefault();
      e.stopPropagation();
      return false;
    } else {
      console.log('🔍 Validation passed, allowing form submission');
    }
  });
}

async function validateZipCode(zipField, stateField) {
  const zip = zipField.value.trim();
  const state = stateField ? stateField.value : '';
  
  console.log('🔍 === ZIP VALIDATION START ===');
  console.log('🔍 ZIP value:', zip);
  console.log('🔍 State field:', stateField);
  console.log('🔍 State value:', state);
  console.log('🔍 State zip ranges available:', !!window.stateZipRanges);
  
  // Clear previous errors
  clearFieldError(zipField);
  
  // Basic format validation
  if (!zip) {
    console.log('🚨 ZIP is empty, showing error');
    showFieldError(zipField, 'ZIP code is required');
    return false;
  }
  
  if (!/^\d{5}(-\d{4})?$/.test(zip)) {
    console.log('🚨 ZIP format invalid, showing error');
    showFieldError(zipField, 'Please enter a valid ZIP code (12345 or 12345-6789)');
    return false;
  }
  
  // State-specific validation
  if (state && window.stateZipRanges) {
    const zipBase = parseInt(zip.substring(0, 5));
    
    // Convert full state name to abbreviation if needed
    const stateAbbr = window.stateNameToAbbr[state] || state;
    const range = window.stateZipRanges[stateAbbr];
    
    console.log('🔍 ZIP base:', zipBase);
    console.log('🔍 Original state:', state);
    console.log('🔍 State abbreviation:', stateAbbr);
    console.log('🔍 State range for', stateAbbr, ':', range);
    
    if (range && (zipBase < range.min || zipBase > range.max)) {
      console.log('🚨 ZIP outside valid range, showing error');
      showFieldError(zipField, `This ZIP code doesn't appear to be in ${state}. Valid range: ${range.min}-${range.max}`);
      return false;
    } else if (!range) {
      console.log('⚠️ No range found for state:', state, '(abbr:', stateAbbr, ')');
    } else {
      console.log('✅ ZIP is within valid range');
    }
  } else {
    console.log('⚠️ State validation skipped - state:', state, 'ranges available:', !!window.stateZipRanges);
  }
  
  console.log('✅ ZIP validation passed');
  console.log('🔍 === ZIP VALIDATION END ===');
  return true;
}

function showFieldError(field, message) {
  // Remove any existing error
  clearFieldError(field);
  
  // Add error class and data attributes to match Customer Fields
  field.classList.add('error', 'invalid');
  field.setAttribute('data-cf-invalid', 'true');
  
  // Find the Customer Fields container
  const cfFieldContainer = field.closest('.cf-field-container');
  const cfField = field.closest('.cf-field');
  
  if (cfField) {
    cfField.setAttribute('data-cf-invalid', 'true');
  }
  
  // Create error message that matches Customer Fields style
  const errorDiv = document.createElement('div');
  errorDiv.className = 'field-error cf-custom-error';
  errorDiv.style.cssText = 'color: #dc3545; font-size: 14px; margin-top: 5px; font-weight: 500;';
  errorDiv.textContent = message;
  
  // Insert after the field container
  if (cfFieldContainer) {
    cfFieldContainer.appendChild(errorDiv);
  } else {
    // Fallback insertion
    const parent = field.parentNode;
    parent.insertBefore(errorDiv, field.nextSibling);
  }
  
  // Scroll to error
  field.scrollIntoView({ behavior: 'smooth', block: 'center' });
  field.focus();
}

function clearFieldError(field) {
  field.classList.remove('error', 'invalid');
  field.removeAttribute('data-cf-invalid');
  
  // Remove error state from Customer Fields containers
  const cfField = field.closest('.cf-field');
  if (cfField) {
    cfField.removeAttribute('data-cf-invalid');
  }
  
  // Remove our custom error messages
  const cfFieldContainer = field.closest('.cf-field-container');
  if (cfFieldContainer) {
    const customErrors = cfFieldContainer.querySelectorAll('.field-error, .cf-custom-error');
    customErrors.forEach(error => error.remove());
  } else {
    // Fallback: look for errors near the field
    const parent = field.parentNode;
    const error = parent.querySelector('.field-error, .cf-custom-error');
    if (error) {
      error.remove();
    }
  }
}


// State name to abbreviation mapping
window.stateNameToAbbr = {
  'Alabama': 'AL', 'Alaska': 'AK', 'Arizona': 'AZ', 'Arkansas': 'AR',
  'California': 'CA', 'Colorado': 'CO', 'Connecticut': 'CT', 'Delaware': 'DE',
  'Florida': 'FL', 'Georgia': 'GA', 'Hawaii': 'HI', 'Idaho': 'ID',
  'Illinois': 'IL', 'Indiana': 'IN', 'Iowa': 'IA', 'Kansas': 'KS',
  'Kentucky': 'KY', 'Louisiana': 'LA', 'Maine': 'ME', 'Maryland': 'MD',
  'Massachusetts': 'MA', 'Michigan': 'MI', 'Minnesota': 'MN', 'Mississippi': 'MS',
  'Missouri': 'MO', 'Montana': 'MT', 'Nebraska': 'NE', 'Nevada': 'NV',
  'New Hampshire': 'NH', 'New Jersey': 'NJ', 'New Mexico': 'NM', 'New York': 'NY',
  'North Carolina': 'NC', 'North Dakota': 'ND', 'Ohio': 'OH', 'Oklahoma': 'OK',
  'Oregon': 'OR', 'Pennsylvania': 'PA', 'Rhode Island': 'RI', 'South Carolina': 'SC',
  'South Dakota': 'SD', 'Tennessee': 'TN', 'Texas': 'TX', 'Utah': 'UT',
  'Vermont': 'VT', 'Virginia': 'VA', 'Washington': 'WA', 'West Virginia': 'WV',
  'Wisconsin': 'WI', 'Wyoming': 'WY'
};

// State ZIP ranges (add more as needed)
window.stateZipRanges = {
  'AL': { min: 35004, max: 36925 },
  'AK': { min: 99501, max: 99950 },
  'AZ': { min: 85001, max: 86556 },
  'AR': { min: 71601, max: 72959 },
  'CA': { min: 90001, max: 96162 },
  'CO': { min: 80001, max: 81658 },
  'CT': { min: 6001, max: 6389 },
  'DE': { min: 19701, max: 19980 },
  'FL': { min: 32004, max: 34997 },
  'GA': { min: 30001, max: 31999 },
  'HI': { min: 96701, max: 96898 },
  'ID': { min: 83201, max: 83877 },
  'IL': { min: 60001, max: 62999 },
  'IN': { min: 46001, max: 47997 },
  'IA': { min: 50001, max: 52809 },
  'KS': { min: 66002, max: 67954 },
  'KY': { min: 40003, max: 42788 },
  'LA': { min: 70001, max: 71497 },
  'ME': { min: 3901, max: 4992 },
  'MD': { min: 20331, max: 21930 },
  'MA': { min: 1001, max: 2791 },
  'MI': { min: 48001, max: 49971 },
  'MN': { min: 55001, max: 56763 },
  'MS': { min: 38601, max: 39776 },
  'MO': { min: 63001, max: 65899 },
  'MT': { min: 59001, max: 59937 },
  'NE': { min: 68001, max: 69367 },
  'NV': { min: 88901, max: 89883 },
  'NH': { min: 3031, max: 3897 },
  'NJ': { min: 7001, max: 8989 },
  'NM': { min: 87001, max: 88441 },
  'NY': { min: 10001, max: 14975 },
  'NC': { min: 27006, max: 28909 },
  'ND': { min: 58001, max: 58856 },
  'OH': { min: 43001, max: 45999 },
  'OK': { min: 73001, max: 74966 },
  'OR': { min: 97001, max: 97920 },
  'PA': { min: 15001, max: 19640 },
  'RI': { min: 2801, max: 2940 },
  'SC': { min: 29001, max: 29948 },
  'SD': { min: 57001, max: 57799 },
  'TN': { min: 37010, max: 38589 },
  'TX': { min: 73301, max: 88595 },
  'UT': { min: 84001, max: 84791 },
  'VT': { min: 5001, max: 5907 },
  'VA': { min: 20040, max: 26886 },
  'WA': { min: 98001, max: 99403 },
  'WV': { min: 24701, max: 26886 },
  'WI': { min: 53001, max: 54990 },
  'WY': { min: 82001, max: 83128 }
};